import * as React from "react";
import { Trans } from "react-i18next";
import { IShipment } from "~/graphql/queries/shipment/shipmentsByIds";
import getOrderNumber, { Order } from "~/helpers/getOrderNumber";

interface IProps {
  order: Order;
  shipment?: IShipment;
}

export default class Processing extends React.Component<IProps> {
  public render() {
    const { order } = this.props;

    return (
      <Trans i18nKey="trackTrace:statusExplanation.processing">
        We zijn bezig met het verwerken van je bestelling met ordernummer{" "}
        <strong>{{ orderNumber: getOrderNumber(order) }}</strong>. Als we je
        betaling ontvangen, wordt je pakket ingepakt en overgedragen aan het
        postbedrijf. Die brengt het pakket naar de luchthaven. Als het daar is
        aangekomen kun je dat hier zien.
      </Trans>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/TrackTrace/Statuses/Processing.tsx